// extracted by mini-css-extract-plugin
module.exports = {"title":"Title-module--title--gpPet"};